import React, { useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';

import Navbar from '../Navbar/Navbar_00';
import Footer from "../Footer/Footer_00";

import { useParams } from "react-router-dom";

// import './Forms.css';
// import parse from 'html-react-parser';

import Swal from 'sweetalert2'

import Loader from '../../../loader';

import * as Hosts from '../../../Hosts';
import {
    set_language,
    //reqGET,
	reqPOST,
    /*repo_banner_link,*/
    content_language,
    passwordHash

} from '../../../Utils';

import { usarToken } from "../../../UseToken";

import { language } from '../WEBContent/Language';


const RecoveryForm = (props) => {

    const [, set_dados] = useState(null);
    const is_logged_in = useRef(null);
    
    const [dados_config, set_dados_config] = useState({});
    const [dados_navbar, set_dados_navbar] = useState({});

    const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false)

    const { hash } = useParams();

    const [lang, set_lang] = useState('pt');
    const [/*lang_id*/, set_lang_id] = useState('1');
    const [/*data*/, /*setData*/] = useState([]); 
    
    const [password_new, set_password_new] = useState(''); 
    const [password_conf, set_password_conf] = useState(''); 

    /*let getInfo = async () => {

        reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/7`)
            .then(res => { 
                setData(res.data)
                //console.log(res.data)

            })
            .catch(erro => alert('Erro'))  

    }*/
 
    useEffect(() => { 
        //getInfo()

        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if(el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

        (async () => {
            let temp_token_info = await usarToken().getToken()
            let token_info = JSON.parse(temp_token_info)
    
            if(token_info !== undefined && token_info !== null) {
                set_dados(is_logged_in.current = true)
            }
            else {
                set_dados(is_logged_in.current = false)
            }
    
            if(is_logged_in.current) {
                if(props.dados_navbar !== undefined && props.dados_navbar !== null && props.dados_navbar !== '') {
                    set_dados_navbar(props.dados_navbar)
                }
            }
    
            if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
                set_dados_config(props.dados_config)
            }
    
            setLoading(false)
        })()
    
    }, [props]); 

    const handleSubmit = async e => {
        e.preventDefault();

        if(password_new !== password_conf) {
            Swal.fire(language[lang].confirmation_password_error_message, '', 'error')
        }
        else {

            reqPOST(Hosts.SIMCore_API + '/entities/password/recovery', {companycode: Hosts.companycode, recovery_hash: hash, new_password: passwordHash(password_new)})
                .then(res => {
                    console.log(res)
  
                    if(res.status === 200) {
                        set_password_new('')
                        set_password_conf('')

                        Swal.fire({
                            icon: "info",
                            title: "",
                            text: language[lang].change_password_sucess_message,
                            showConfirmButton: false,
                            timer: 2000
                        });

                        setTimeout(() => {                        
                            setRedirect(true)
                        }, 2000)

                    }
                    else {
                        Swal.fire(language[lang].change_password_expiration_message, '', 'error')
                    }
                    
            
                })
                .catch(() => 404)
        }
    }
        
    return(
        isRedirect ? 
            <Redirect to={'/'} replace />
        :
        isloading ?
            <Loader />
        :
            <div>
                <Navbar pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />

                <section id="recovery">
                    <div className='container-fluid'>
                        <div className="row">
                            <div className='col-12 bg-light py-5'>
                                <div className='container'>
                                    <div className='row'>
                                        <div className='col-12 text-center'>
                                            <h3 className="titulo-primario">
                                                <span>{language[lang].contact_recovery}</span>
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className='container my-5'>
                            <div className='row'>
                                <div className='col-6 col-md-4 text-center mx-auto my-5'>
                                    <div className="form-group mb-3">
                                        <label>{language[lang].password_new}*</label>
                                        <input type="password" name="password_new" value={password_new} className="form-input w-100 form-control-lg rounded-0 border-0 bg-color-gray-light" placeholder="" onChange={(e) => set_password_new(e.target.value)} required />
                                    </div>                            
                                    <div className="form-group mb-3">
                                        <label>{language[lang].password_conf}*</label>
                                        <input type="password" name="password_conf" value={password_conf} className="form-input w-100 form-control-lg rounded-0 border-0 bg-color-gray-light" placeholder="" onChange={(e) => set_password_conf(e.target.value)} required />
                                    </div>
                                    <div className="form-group mt-5">
                                        <button className="btn btn-primary">
                                            {language[lang].send}
                                        </button>
                                    </div>
                                </div> 
                            </div>
                        </div>                       
                    </form>
                </section>

                <Footer pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />
            </div>
    );


};

export default RecoveryForm;